export default "__VITE_ASSET__5fijZz9Y__"